// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-node_modules_fullcalendar_angular___ivy_ngcc___fesm2015_fullcalendar-angular_js":"04b9c6c48d5bd832","src_app_calendar_calendar_module_ts":"c035dac914c7efbe"}[chunkId] + ".css";
};